import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { GroupByOption } from "@models/grid/grid-filter";
import { BaseListGridComponent } from "@shared/components/grid/components/base-list-grid/base-list-grid.component";
import { GridService } from "@shared/services/grid.service";
import { RowModelType } from "ag-grid-community";

@Component({
  selector: 'app-base-grid',
  standalone: true,
  template: '',
})
export class BaseGridComponent extends BaseListGridComponent {
  gridService = inject(GridService);
  destroyRef: DestroyRef = inject(DestroyRef);

  @Input() pageTitle = '';
  @Input() loading = false;
  @Input() rowData: unknown[] = [];
  @Input() totalRows = 0;
  @Input() groupByOptions: GroupByOption[] = [];
  @Input() hideSearch = false;//if pinFirstColumnName is set, then the column with this name will be pinned as a first column
  @Input() pinFirstColumnName: string | undefined;

  @Output() search = new EventEmitter<string>();
  @Output() selectGroupByOption = new EventEmitter<number>();
  @Output() clearGroupByOption = new EventEmitter<boolean>();

  readonly rowModelType: RowModelType = 'serverSide';

  form = new FormGroup({
    search: new FormControl<string>('', { nonNullable: true }),
  });

  get searchInputPlaceholder(): string {
    return 'Search ' + this.pageTitle.toLowerCase() + '...';
  }
}
